import { cn } from '@tripleten/cn';

export const cnBox = cn('box');
